import { useStatsOrdersUnreconciled } from "../../api/hooks/stats";

const AgingReturns = () => {
  const { data } = useStatsOrdersUnreconciled();
  return (
    <div className="flex flex-col gap-4 rounded-xl border-2 pb-4">
      <div className="flex gap-2 rounded-t-xl bg-[#D1DFFF] px-6 py-1 text-lg">
        <div>Aging Returns</div>
      </div>
      <div className="flex flex-grow justify-between gap-6 divide-x px-16">
        <div className="flex-grow text-center">
          <p className="">Unreconciled Orders</p>
          <p className="text-lg font-bold">{data?.unreconciled?.count || 0}</p>
        </div>
        <div className="flex-grow text-center">
          <p className="">Unaccounted</p>
          <p className="">{data?.unreconciled?.quantity || 0} Qty</p>
        </div>
      </div>
    </div>
  );
};

export default AgingReturns;
